'use strict';

var _defineProperties = require('babel-runtime/core-js/object/define-properties');

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  mutation register ($input: RegisterInput!) {\n    register(input: $input)\n  }\n'], ['\n  mutation register ($input: RegisterInput!) {\n    register(input: $input)\n  }\n']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _reactApollo = require('react-apollo');

function _taggedTemplateLiteral(strings, raw) { return (0, _freeze2.default)((0, _defineProperties2.default)(strings, { raw: { value: (0, _freeze2.default)(raw) } })); }

exports.default = (0, _reactApollo.gql)(_templateObject);